// extracted by mini-css-extract-plugin
export default {"textPrice":"TextPrice_textPrice__ZMgso"};